var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1916008_instagram_logo_media_social_icon",
    clipPath: "url(#clip0_3657_10786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5837 21.0837H6.41699C4.9583 21.0837 3.55935 20.5042 2.5279 19.4727C1.49645 18.4413 0.916992 17.0423 0.916992 15.5837V6.41699C0.916992 4.9583 1.49645 3.55935 2.5279 2.5279C3.55935 1.49645 4.9583 0.916992 6.41699 0.916992H15.5837C17.0423 0.916992 18.4413 1.49645 19.4727 2.5279C20.5042 3.55935 21.0837 4.9583 21.0837 6.41699V15.5837C21.0837 17.0423 20.5042 18.4413 19.4727 19.4727C18.4413 20.5042 17.0423 21.0837 15.5837 21.0837ZM6.41699 2.75033C5.44453 2.75033 4.5119 3.13663 3.82427 3.82427C3.13663 4.5119 2.75033 5.44453 2.75033 6.41699V15.5837C2.75033 16.5561 3.13663 17.4887 3.82427 18.1764C4.5119 18.864 5.44453 19.2503 6.41699 19.2503H15.5837C16.5561 19.2503 17.4887 18.864 18.1764 18.1764C18.864 17.4887 19.2503 16.5561 19.2503 15.5837V6.41699C19.2503 5.44453 18.864 4.5119 18.1764 3.82427C17.4887 3.13663 16.5561 2.75033 15.5837 2.75033H6.41699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 16.5C9.91221 16.5 8.84884 16.1774 7.94437 15.5731C7.0399 14.9687 6.33495 14.1098 5.91867 13.1048C5.50238 12.0998 5.39346 10.9939 5.60568 9.92701C5.8179 8.86011 6.34173 7.8801 7.11092 7.11092C7.8801 6.34173 8.86011 5.8179 9.92701 5.60568C10.9939 5.39346 12.0998 5.50238 13.1048 5.91867C14.1098 6.33495 14.9687 7.0399 15.5731 7.94437C16.1774 8.84884 16.5 9.91221 16.5 11C16.5 12.4587 15.9205 13.8576 14.8891 14.8891C13.8576 15.9205 12.4587 16.5 11 16.5ZM11 7.33334C10.2748 7.33334 9.56589 7.54838 8.96291 7.95128C8.35993 8.35418 7.88997 8.92683 7.61244 9.59683C7.33492 10.2668 7.26231 11.0041 7.40379 11.7153C7.54527 12.4266 7.89448 13.0799 8.40728 13.5927C8.92007 14.1055 9.57341 14.4547 10.2847 14.5962C10.9959 14.7377 11.7332 14.6651 12.4032 14.3876C13.0732 14.11 13.6458 13.6401 14.0487 13.0371C14.4516 12.4341 14.6667 11.7252 14.6667 11C14.6667 10.0275 14.2804 9.09491 13.5927 8.40728C12.9051 7.71964 11.9725 7.33334 11 7.33334Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5007 5.50033C17.0069 5.50033 17.4173 5.08992 17.4173 4.58366C17.4173 4.0774 17.0069 3.66699 16.5007 3.66699C15.9944 3.66699 15.584 4.0774 15.584 4.58366C15.584 5.08992 15.9944 5.50033 16.5007 5.50033Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3657_10786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.502dbb39934953566e5df31e0eacbe42.svg";
export { ForwardRef as ReactComponent };